import { useDelete } from '../../../sharedModules/hooks/useQuery';

export function useRemoveUser() {
  return useDelete();
}

export function removeUserVariables(userId: number) {
  return { url: `/collections/department_assignments/${userId}` };
}
